import { useCallback, useEffect, useMemo, useState } from 'react';
// @mui material components
import {
	Card,
	Grid,
	Modal,
	Typography,
	Box,
	NativeSelect,
	InputLabel,
	Tooltip,
	IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FormField from 'layouts/pages/account/components/FormField';
// // Material Dashboard 2 PRO React TS components
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';
import MDPagination from 'components/MDPagination';

// Material Dashboard 2 PRO React TS examples components
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import DataTable from 'components/Tables/DataTable';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// Data
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';

//Actions
import servCliente from '../../actions/Clientes/clientes';
import servFormPago from '../../actions/Catalogo/forma_Pago';
import servMetodoPago from '../../actions/Catalogo/metodo_pago';
import { cliente, initcliente } from '../../actions/Clientes/clientesTypes';
import { iMensaje } from '../../Utilidades/mensaje.interface';
import Swal from 'sweetalert2';
import { CSVLink } from 'react-csv';
import { getEntidadesByPais, getRegimenes } from 'actions/MiCuenta/miCuenta';
import { LOADING_END, START_LOADING } from 'actions/Loading/loadingTypes';
import { useDispatch, useSelector } from 'react-redux';
import { RootStore } from 'store/Store';
import PXLoader from 'components/PXLoader/PXLoader';
import Icon from '@mui/material/Icon';

function Comprobantes(): JSX.Element {
	const dispatch = useDispatch();
	const { loading } = useSelector((state: RootStore) => state.loading);
	const [open, setOpen] = useState(false);
	const handleOpen = () => {
		setOpen(true);
		reset();
	};
	const handleClose = (event?: object, reason?: string) => {
		if (reason && reason == 'backdropClick') return;
		setOpen(false);
		reset();
	};
	const [dataTableData, setdataTableData] = useState({
		columns: [],
		rows: [],
	});
	const [modo, setModo] = useState(0);
	const [titulo, setTitulo] = useState('');
	const [colFormaPago, setcolFormaPago] = useState([]);
	const [colMetodoPago, setcolMetodoPago] = useState([]);
	const [isNombre, setIsNombre] = useState(false);
	const [isRFC, setIsRFC] = useState(false);
	const [isEmail, setIsEmail] = useState(false);
	const [isCP, setIsCP] = useState(false);
	const [isTipoContribuyente, setIsTipoContribuyente] = useState(false);
	const [isRegimenFiscal, setIsRegimenFiscal] = useState(false);
	const [isMetodoPago, setIsMetodoPago] = useState(false);
	const [isFormaPago, setIsFormaPago] = useState(false);
	const [isDisable, setIsDisable] = useState(false);
	const [formValue, setFormValue] = useState(initcliente);
	const [estadosList, setEstadosList] = useState([]);
	const [regimenes, setRegimenes] = useState([]);
	const [page, setPage] = useState(1);
	const [limit] = useState(10);
	const [total, setTotal] = useState(0);
	const [search, setSearch] = useState('');
	const totalPages = useMemo(
		() => Math.max(Math.ceil(total / limit), 1),
		[limit, total]
	);
	const rowsCount = Array.isArray(dataTableData.rows) ? dataTableData.rows.length : 0;
	const reset = () => {
		setFormValue(initcliente);
	};

	const handleInputChange = ({ target }: any) => {
		setFormValue({
			...formValue,
			[target.name]: target.value,
		});
	};

	const columns: any = useMemo(
		() => [
			{ Header: 'Razón Social', accessor: 'nombre', width: '25%', align: 'center' },
			{ Header: 'R.F.C.', accessor: 'rfc', width: '20%' },
			{ Header: 'Teléfono', accessor: 'telefono', width: '20%' },
			{ Header: 'Correo', accessor: 'email', width: '25%' },
			{ Header: 'Acciones', accessor: 'acciones', width: '10%', align: 'center' },
		],
		[]
	);

	const loadData = useCallback(
		(datos: cliente[]) => {
			const rows = datos.map((item) => {
				return {
					nombre: item.nombre,
					rfc: item.rfc,
					telefono: item.telefono,
					email: item.email ? item.email : '123',
					acciones: <IconsCell obj={item} />,
				};
			});
			setdataTableData({ columns, rows });
		},
		[columns]
	);

	const fetchClientes = useCallback(async () => {
		dispatch({ type: START_LOADING });
		try {
			const respuesta = await servCliente.list({
				page,
				limit,
				q: search,
				sortBy: 'nombre',
				sortDir: 'ASC',
			});
			const payload = respuesta.data;
			const registros = Array.isArray(payload) ? payload : payload?.data || [];
			const totalRegistros = Array.isArray(payload)
				? payload.length
				: payload?.meta?.total || 0;
			const totalPagesResponse = Array.isArray(payload)
				? 1
				: payload?.meta?.totalPages || 1;
			setTotal(totalRegistros);
			if (page > totalPagesResponse && totalPagesResponse >= 1) {
				setPage(totalPagesResponse);
				return;
			}
			loadData(registros);
		} catch (error: any) {
			const status = error?.response?.status;
			if (status === 404) {
				setdataTableData({ columns, rows: [] });
				setTotal(0);
			} else {
				console.log(`error${status}`, error?.response?.data || error);
			}
		} finally {
			dispatch({ type: LOADING_END });
		}
	}, [columns, dispatch, limit, loadData, page, search]);

	//Obtiene data
	useEffect(() => {
		getCombos();
		const data = getRegimenes();
		data
			.then((respuesta) => {
				if (respuesta.status === 201) {
					setRegimenes(respuesta.data);
				}
			})
			.catch((error) => {
				if (error.response.status === 500) {
					console.log('error500');
					console.log(error.response.data.message);
				} else if (error.response.status === 400) {
					console.log('error400');
					console.log(error.response.data.message);
				} else if (error.response.status === 403) {
					console.log('error403');
					console.log(error.response.data.message);
				} else if (error.response.status === 404) {
					console.log('error404');
					console.log(error.response.data.message);
				} else {
					console.log(error.response.data.message);
				}
			});
	}, []);

	useEffect(() => {
		fetchClientes();
	}, [fetchClientes]);
	useEffect(() => {
		//Get Entidades
		let pais = '';
		if (formValue.pais === 'México') pais = 'MEX';
		else if (formValue.pais === 'USA') pais = 'USA';
		else if (formValue.pais === 'Canada') pais = 'CAN';

		const dataEntidades = getEntidadesByPais(pais);
		dataEntidades
			.then((respuesta) => {
				if (respuesta.status === 200) {
					setEstadosList(respuesta.data);
				}
			})
			.catch((error) => {
				if (error.response.status === 500) {
					console.log('error500');
					console.log(error.response);
				} else if (error.response.status === 400) {
					console.log('error400');
					console.log(error.response);
				} else if (error.response.status === 403) {
					console.log('error403');
					console.log(error.response);
				} else if (error.response.status === 404) {
					console.log('error404');
					console.log(error.response);
				} else {
					console.log(error.response);
				}
			});
	}, [formValue.pais]);

	const getCombos = () => {
		servFormPago
			.get()
			.then((r) => {
				const colData = r.data.map(
					(item: { c_FormaPago: string; descripcion: string }) => {
						return {
							c_FormaPago: item.c_FormaPago,
							descripcion: item.descripcion,
						};
					}
				);
				setcolFormaPago(colData);
			})
			.catch((e) => console.error('Error cargar formas de pago', e));
		servMetodoPago
			.get()
			.then((r) => {
				const colData = r.data.map(
					(item: { c_MetodoPago: string; descripcion: string }) => {
						return {
							c_MetodoPago: item.c_MetodoPago,
							descripcion: item.descripcion,
						};
					}
				);
				setcolMetodoPago(colData);
			})
			.catch((e) => console.error('Error cargar metodos de pago', e));
	};

	const modoModal = (modo: number, obj: cliente) => {
		limpiamos();
		setModo(modo);
		switch (modo) {
			case 1: //Editar
				handleOpen();
				setTitulo('Actualizar Cliente');
				loadForm(obj);
				break;
			case 2: //Eliminar
				eliminarregistro(obj.id);
				break;
			case 3: //Detalle
				handleOpen();
				setTitulo('Detalle del Cliente');
				setIsDisable(true);
				loadForm(obj);
				break;
		}
	};

	const loadForm = (obj: cliente) => {
		try {
			setFormValue(obj);
		} catch (e) {
			console.log('Error al cargar datos al modal:', e);
		}
	};

	const eliminarregistro = (id: number) => {
		Swal.fire({
			icon: 'question',
			title: '¿Estas seguro de eliminar el siguiente registro?',
			showCancelButton: true,
			confirmButtonText: '!Eliminar!',
			confirmButtonColor: '#00ACC8',
		}).then((r) => {
			/* Read more about isConfirmed, isDenied below */
			if (r.isConfirmed) {
				servCliente
					.delete(id)
					.then((r) => procesamosResponse(r.data))
					.catch((e) => console.log(e));
			}
		});
	};

	const crear = () => {
		handleOpen();
		limpiamos();
		setModo(0);
		setTitulo('Crear Cliente');
	};

	const acciones = async () => {
		switch (modo) {
			case 0: //Crear
				await servCliente
					.post(formValue)
					.then((r) => {
						procesamosResponse(r.data);
					})
					.catch((e) => {
						procesamosResponse(e.response.data);
					});
				break;
			case 1: //Actualizar
				await servCliente
					.update(formValue.id, formValue)
					.then((r) => {
						procesamosResponse(r.data);
					})
					.catch((e) => {
						procesamosResponse(e.response.data);
					});
				break;
		}
	};

	const procesamosResponse = (resp: any) => {
		let r: iMensaje[] = resp.messages;
		r.forEach((e) => {
			switch (e.tipo) {
				case 1: //Mensaje Error
					toast.error(e.mensaje);
					break;
				case 2: //Atributos con error
					switch (e.mensaje) {
						case 'nombre':
							setIsNombre(true);
							break;
						case 'rfc':
							setIsRFC(true);
							break;
						case 'codigo_postal':
							setIsCP(true);
							break;
						case 'codigo_postal':
							setIsCP(true);
							break;
						case 'codigo_postal':
							setIsCP(true);
							break;
						case 'codigo_postal':
							setIsCP(true);
							break;
						case 'forma_de_pago':
							setIsCP(true);
							break;
					}
					console.log('Atributos', e.mensaje);
					break;
				case 3: //Exitoso
					switch (modo) {
						case 2:
							Swal.fire('Eliminado!', '', 'success');
							break;
						default:
							toast.success(e.mensaje);
							handleClose();
							limpiamos();
							break;
					}
					fetchClientes();
					break;
				case 4: //Informativo
					toast.info(e.mensaje);
					break;
				case 5: //Parametro
					break;
			}
		});
	};

	const limpiamos = () => {
		setIsEmail(false);
		setIsNombre(false);
		setIsRFC(false);
		setIsDisable(false);
	};

	const IconsCell = (item: { obj: cliente }) => {
		return (
			<MDBox display='flex' alignItems='center'>
				<MDBox mr={2}>
					<Tooltip title='Editar'>
						<IconButton color='warning' onClick={() => modoModal(1, item.obj)}>
							<EditIcon />
						</IconButton>
					</Tooltip>
				</MDBox>
				<MDBox mr={2}>
					<Tooltip title='Ver'>
						<IconButton color='info' onClick={() => modoModal(3, item.obj)}>
							<VisibilityIcon />
						</IconButton>
					</Tooltip>
				</MDBox>
				<MDBox mr={2}>
					<Tooltip title='Eliminar'>
						<IconButton color='error' onClick={() => modoModal(2, item.obj)}>
							<DeleteIcon />
						</IconButton>
					</Tooltip>
				</MDBox>
			</MDBox>
		);
	};

	return (
		<DashboardLayout>
			<DashboardNavbar />
			{/* Tabla */}
			<MDBox pt={6} pb={3}>
				<Card>
					<MDBox p={3} lineHeight={1}>
						<MDTypography variant='h5' fontWeight='medium' color='primary'>
							Clientes
						</MDTypography>
						<Grid
							container
							direction='row'
							justifyContent='flex-end'
							alignItems='flex-end'
							spacing={1}
						>
							<MDButton size='small' color='primary' onClick={() => crear()}>
								+ Agregar
							</MDButton>
							<CSVLink
								data={dataTableData.rows.map((d) => {
									return {
										nombre: d.nombre,
										rfc: d.rfc,
										telefono: d.telefono,
										email: d.email,
									};
								})}
								filename='Clientes.csv'
							>
								<MDButton size='small' sx={{ marginLeft: '1rem', border: '1px solid' }}>
									+ Exportar CSV
								</MDButton>
							</CSVLink>
						</Grid>
					</MDBox>

					<DataTable
						table={dataTableData}
						canSearch
						entriesPerPage={false}
						showTotalEntries={false}
						onServerSearch={(value: string) => {
							setPage(1);
							setSearch(value.trim());
						}}
					/>
					<MDBox display='flex' justifyContent='space-between' alignItems='center' p={2}>
						<MDTypography variant='button' color='secondary' fontWeight='regular'>
							Mostrando {rowsCount} de {total} registros
						</MDTypography>
						<MDPagination>
							{page > 1 && (
								<MDPagination item onClick={() => setPage(1)}>
									<Icon sx={{ fontWeight: 'bold' }} style={{ marginLeft: '2px' }}>
										chevron_left
									</Icon>
									<Icon sx={{ fontWeight: 'bold' }} style={{ marginLeft: '-10px' }}>
										chevron_left
									</Icon>
								</MDPagination>
							)}
							{page > 1 && (
								<MDPagination item onClick={() => setPage(page - 1)}>
									<Icon sx={{ fontWeight: 'bold' }}>chevron_left</Icon>
								</MDPagination>
							)}
							<MDTypography variant='caption' color='secondary' sx={{ mx: 2 }}>
								Página {page} de {totalPages}
							</MDTypography>
							{page < totalPages && (
								<MDPagination item onClick={() => setPage(page + 1)}>
									<Icon sx={{ fontWeight: 'bold' }}>chevron_right</Icon>
								</MDPagination>
							)}
							{page < totalPages && (
								<MDPagination item onClick={() => setPage(totalPages)}>
									<Icon sx={{ fontWeight: 'bold' }} style={{ marginLeft: '2px' }}>
										chevron_right
									</Icon>
									<Icon sx={{ fontWeight: 'bold' }} style={{ marginLeft: '-10px' }}>
										chevron_right
									</Icon>
								</MDPagination>
							)}
						</MDPagination>
					</MDBox>
					{loading && (
						<>
							<MDBox m={4}>
								<PXLoader />
							</MDBox>
						</>
					)}
				</Card>
			</MDBox>
			<Modal
				open={open}
				onClose={handleClose}
				aria-labelledby='modal-modal-title'
				aria-describedby='modal-modal-description'
			>
				<Box sx={style}>
					<Tooltip title='Cerrar'>
						<IconButton
							onClick={() => handleClose()}
							color='secondary'
							aria-label='upload picture'
							component='label'
							style={{
								position: 'absolute',
								top: '-10px',
								right: '-10px',
								backgroundColor: '#fff',
								border: '1px solid #00ACC8',
							}}
						>
							<CloseIcon />
						</IconButton>
					</Tooltip>
					<Typography id='modal-modal-title' variant='h5' component='h2' pb={1}>
						{titulo}
					</Typography>
					{!isDisable && (
						<>
							<MDBox>
								<MDTypography variant='body2'>
									Todos los campos con * son obligatorios
								</MDTypography>
							</MDBox>
							<MDBox
								mb={2}
								mt={1}
								style={{
									maxWidth: '680px',
									lineHeight: '18px',
									fontSize: '15px',
									textAlign: 'justify',
									backgroundColor: '#e1a90244',
									border: '2px solid #ffbf00',
									padding: '10px',
									borderRadius: '8px',
								}}
							>
								<MDTypography variant='captions' style={{ color: '#383838' }}>
									NOTA: Los datos ingresados en esta sección deberan coincidir
									exactamente con los registrados ante el SAT, respetando Mayúsculas,
									Minúsculas, Espacios, Acentos y Signos de puntuación.
								</MDTypography>
							</MDBox>
						</>
					)}
					<MDBox component='form' pb={3} px={3}>
						<Grid container spacing={3}>
							<Grid item xs={12} sm={4}>
								<FormField
									label='Nombre o razón social*'
									placeholder='Nombre o razón social*'
									value={formValue.nombre}
									onChange={handleInputChange}
									name='nombre'
									type='text'
									error={isNombre}
									disabled={isDisable}
								/>
							</Grid>
							<Grid item xs={12} sm={4}>
								<FormField
									label='RFC*'
									placeholder='RFC*'
									value={formValue.rfc}
									onChange={handleInputChange}
									name='rfc'
									type='text'
									error={isRFC}
									disabled={isDisable}
								/>
							</Grid>
							<Grid item xs={12} sm={4}>
								<FormField
									label='C.P*'
									placeholder='C.P*'
									value={formValue.codigo_postal}
									onChange={handleInputChange}
									name='codigo_postal'
									type='text'
									error={isCP}
									disabled={isDisable}
								/>
							</Grid>
							<Grid item xs={12} sm={4}>
								<FormField
									label='Calle'
									placeholder='Calle'
									value={formValue.calle}
									onChange={handleInputChange}
									name='calle'
									type='text'
									disabled={isDisable}
								/>
							</Grid>
							<Grid item xs={12} sm={4}>
								<FormField
									label='# Exterior'
									placeholder='# Exterior'
									value={formValue.no_exterior}
									onChange={handleInputChange}
									name='no_exterior'
									type='text'
									disabled={isDisable}
								/>
							</Grid>
							<Grid item xs={12} sm={4}>
								<FormField
									label='# Interior'
									placeholder='# Interior'
									value={formValue.no_interior}
									onChange={handleInputChange}
									name='no_interior'
									type='text'
									disabled={isDisable}
								/>
							</Grid>
							<Grid item xs={12} sm={4}>
								<MDBox
									style={
										isDisable
											? { width: '100%', backgroundColor: '#EFF2F5' }
											: { width: '100%' }
									}
								>
									<InputLabel variant='standard' htmlFor='uncontrolled-native'>
										País
									</InputLabel>
									<NativeSelect
										disabled={isDisable}
										onChange={handleInputChange}
										value={formValue.pais}
										inputProps={{
											name: 'pais',
											id: 'uncontrolled-native',
										}}
										style={{ width: '100%' }}
										required
									>
										<option value={''}>Seleccione una opción</option>
										<option value={'México'}>México</option>
										<option value={'USA'}>USA</option>
										<option value={'Canada'}>Canada</option>
									</NativeSelect>
								</MDBox>
							</Grid>
							<Grid item xs={12} sm={4}>
								<MDBox
									style={
										isDisable
											? { width: '100%', backgroundColor: '#EFF2F5' }
											: { width: '100%' }
									}
								>
									<InputLabel variant='standard' htmlFor='uncontrolled-native'>
										Estado
									</InputLabel>
									<NativeSelect
										disabled={isDisable}
										onChange={handleInputChange}
										value={formValue.estado}
										inputProps={{
											name: 'estado',
											id: 'uncontrolled-native',
										}}
										style={{ width: '100%' }}
										required
									>
										<option value={''}>Seleccione una opción</option>
										{estadosList.map((item) => (
											<option key={item.id} value={item.nombre}>
												{item.nombre}
											</option>
										))}
									</NativeSelect>
								</MDBox>
							</Grid>
							<Grid item xs={12} sm={4}>
								<FormField
									label='Localidad'
									placeholder='Localidad'
									value={formValue.localidad}
									onChange={handleInputChange}
									name='localidad'
									type='text'
									disabled={isDisable}
								/>
							</Grid>
							<Grid item xs={12} sm={4}>
								<FormField
									label='Alcaldia/Municipio'
									placeholder='Alcaldia/Municipio'
									value={formValue.municipio}
									onChange={handleInputChange}
									name='municipio'
									type='text'
									disabled={isDisable}
								/>
							</Grid>
							<Grid item xs={12} sm={4}>
								<FormField
									label='Colonia'
									placeholder='Colonia'
									value={formValue.colonia}
									onChange={handleInputChange}
									name='colonia'
									type='text'
									disabled={isDisable}
								/>
							</Grid>

							<Grid item xs={12} sm={4}>
								<FormField
									label='Referencia'
									placeholder='Referencia:'
									value={formValue.referencia}
									onChange={handleInputChange}
									name='referencia'
									type='text'
									disabled={isDisable}
								/>
							</Grid>
							<Grid item xs={12} md={4}>
								<FormField
									label='Teléfono'
									placeholder='Teléfono'
									inputProps={{ type: 'number' }}
									value={formValue.telefono}
									onChange={handleInputChange}
									name='telefono'
									type='text'
									disabled={isDisable}
								/>
							</Grid>
							<Grid item xs={12} sm={4}>
								<FormField
									label='email'
									placeholder='example@email.com'
									inputProps={{ type: 'email' }}
									value={formValue.email}
									onChange={handleInputChange}
									name='email'
									type='text'
									error={isEmail}
									disabled={isDisable}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<MDBox
									style={
										isDisable
											? { width: '100%', backgroundColor: '#EFF2F5' }
											: { width: '100%' }
									}
								>
									<InputLabel
										variant='standard'
										htmlFor='selectTipoContribuyenteWizardCliente'
									>
										Tipo Contribuyente*
									</InputLabel>
									<NativeSelect
										disabled={isDisable}
										onChange={handleInputChange}
										value={formValue.tipo_Persona}
										inputProps={{
											name: 'tipo_Persona',
											id: 'selectTipoContribuyenteWizardCliente',
										}}
										style={{ width: '100%' }}
										error={isTipoContribuyente}
										required
									>
										<option value={''}>Seleccione una opción*</option>
										<option value={'Persona Fisica'}>Persona Fisica</option>
										<option value={'Persona Moral'}>Persona Moral</option>
									</NativeSelect>
								</MDBox>
							</Grid>
							<Grid item xs={12} sm={6}>
								<MDBox
									style={
										isDisable
											? { width: '100%', backgroundColor: '#EFF2F5' }
											: { width: '100%' }
									}
								>
									<InputLabel variant='standard' htmlFor='selectRegimenWizardCliente'>
										Régimen Fiscal*
									</InputLabel>
									<NativeSelect
										disabled={isDisable}
										onChange={handleInputChange}
										value={formValue.c_regimen_fiscal_Cliente}
										inputProps={{
											name: 'c_regimen_fiscal_Cliente',
											id: 'selectRegimenWizardCliente',
										}}
										style={{ width: '100%' }}
										error={isRegimenFiscal}
										required
									>
										<option value={''}>Seleccione una opción*</option>
										{regimenes.map((item) => (
											<option key={item.id} value={item.c_RegimenFiscal}>
												{`${item.c_RegimenFiscal} - ${item.descripcion}`}
											</option>
										))}
									</NativeSelect>
								</MDBox>
							</Grid>
							<Grid item xs={12} sm={6}>
								<MDBox
									style={
										isDisable
											? { width: '100%', backgroundColor: '#EFF2F5' }
											: { width: '100%' }
									}
								>
									<InputLabel variant='standard' htmlFor='uncontrolled-native'>
										Método de Pago*
									</InputLabel>
									<NativeSelect
										disabled={isDisable}
										onChange={handleInputChange}
										value={formValue.metodo_de_pago}
										inputProps={{
											name: 'metodo_de_pago',
											id: 'uncontrolled-native',
										}}
										style={{ width: '100%' }}
										error={isMetodoPago}
										required
									>
										<option value={''}>Seleccione una opción*</option>
										{colMetodoPago.map((item) => (
											<option key={item.c_MetodoPago} value={item.c_MetodoPago}>
												{`${item.c_MetodoPago} - ${item.descripcion}`}
											</option>
										))}
									</NativeSelect>
								</MDBox>
							</Grid>
							<Grid item xs={12} sm={6}>
								<MDBox
									style={
										isDisable
											? { width: '100%', backgroundColor: '#EFF2F5' }
											: { width: '100%' }
									}
								>
									<InputLabel variant='standard' htmlFor='uncontrolled-native'>
										Forma de Pago*
									</InputLabel>
									<NativeSelect
										disabled={isDisable}
										onChange={handleInputChange}
										value={formValue.forma_de_pago}
										inputProps={{
											name: 'forma_de_pago',
											id: 'uncontrolled-native',
										}}
										style={{ width: '100%' }}
										error={isFormaPago}
										required
									>
										<option value={''}>Seleccione una opción*</option>
										{colFormaPago.map((item) => (
											<option key={item.c_FormaPago} value={item.c_FormaPago}>
												{`${item.c_FormaPago} - ${item.descripcion}`}
											</option>
										))}
									</NativeSelect>
								</MDBox>
							</Grid>
						</Grid>
					</MDBox>
					{isDisable ? (
						<Grid
							container
							direction='row'
							justifyContent='flex-end'
							alignItems='flex-end'
							spacing={1}
						>
							<MDButton size='small' color='primary' onClick={handleClose}>
								Cerrar
							</MDButton>
						</Grid>
					) : (
						<Grid
							container
							direction='row'
							justifyContent='flex-end'
							alignItems='flex-end'
							spacing={1}
						>
							<MDButton size='small' onClick={handleClose}>
								Cancelar
							</MDButton>
							<MDButton size='small' color='primary' onClick={acciones}>
								Guardar
							</MDButton>
						</Grid>
					)}
				</Box>
			</Modal>
		</DashboardLayout>
	);
}

const style = {
	position: 'absolute' as 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 900,
	bgcolor: 'background.paper',
	boxShadow: 24,
	p: 4,
	toast: {
		position: 'absolute' as 'absolute',
		top: 0,
		right: 0,
	},
	toastH: {
		position: 'relative' as 'relative',
	},
};

export default Comprobantes;
